import { useQuery } from '@tanstack/react-query'
import { dashboardAPI } from '../services/api'

// Dashboard data fetcher
const fetchDashboardData = async () => {
  try {
    const response = await dashboardAPI.getDashboardData()
    // API'den gelen data format: { success: true, data: { metrics: {}, ... } }
    // Dashboard component'i direkt data içeriğini bekliyor
    return response.data.data
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Dashboard verileri alınamadı')
  }
}

// Dashboard data hook
export const useDashboardData = () => {
  return useQuery({
    queryKey: ['dashboardData'],
    queryFn: fetchDashboardData,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (was cacheTime)
    refetchInterval: 30 * 1000, // Refetch every 30 seconds
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    retry: 1,
    onError: (error) => {
      console.error('Dashboard data fetch error:', error)
    },
  })
}

// Individual metric hooks for more granular control
export const useMetrics = () => {
  return useQuery({
    queryKey: ['metrics'],
    queryFn: async () => {
      const response = await dashboardAPI.getMetrics()
      return response.data.data
    },
    staleTime: 2 * 60 * 1000, // 2 minutes
    refetchInterval: 60 * 1000, // Refetch every minute
  })
}

export const useRevenueChart = (days = 30) => {
  return useQuery({
    queryKey: ['revenueChart', days],
    queryFn: async () => {
      const response = await dashboardAPI.getRevenueChart(days)
      return response.data.data
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
  })
}

export const useRecentTransactions = (limit = 10) => {
  return useQuery({
    queryKey: ['recentTransactions', limit],
    queryFn: async () => {
      const response = await dashboardAPI.getRecentTransactions(limit)
      return response.data.data
    },
    staleTime: 1 * 60 * 1000, // 1 minute
    refetchInterval: 30 * 1000, // Refetch every 30 seconds
  })
}

export const useSystemHealth = () => {
  return useQuery({
    queryKey: ['systemHealth'],
    queryFn: async () => {
      const response = await dashboardAPI.getSystemHealth()
      return response.data.data
    },
    staleTime: 30 * 1000, // 30 seconds
    refetchInterval: 60 * 1000, // Refetch every minute
    refetchIntervalInBackground: true,
  })
}